import React from 'react';
import ProductInterface from '../ProductInterface';
import ConhrlyOptions from './ConhrlyOptions';
import { processConhrly } from './conhrlyProcess';

export default function Conhrly() {
  return (
      <ProductInterface
          product = "conhrly"
          ProductOptions = {ConhrlyOptions}
          processProduct = {processConhrly}
      />
  )
} 